module.exports = __webpack_public_path__ + "img/chemity_logo_branding.0b823e13.png";